// InfoCards.js
import React from 'react';
import { Card, CardContent, Typography, IconButton, Box } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const InfoCards = ({ navigate }) => {
  const cardStyle = {
    backgroundColor: "#d8ccba",
    borderTopLeftRadius: "24px",
    borderBottomRightRadius: "24px",
    overflow: "hidden",
    boxShadow: "0 13px 30px rgba(0, 0, 0, 0.4), 0 6px 10px rgba(0, 0, 0, 0.35)",
    cursor: "pointer",
    transform: "perspective(1000px)",
    transition: "transform 0.4s ease, box-shadow 0.4s ease",
    "&:hover": {
      transform: "perspective(1000px) scale(1.03) rotateX(2deg)",
      boxShadow: "0 28px 40px rgba(0, 0, 0, 0.5), 0 10px 20px rgba(0, 0, 0, 0.4)",
    },
  };

  const infoCards = [
    { title: "JV / JD / Built to Suit", onClick: () => navigate("/jvjd") },
    { title: "Customers Wanted Properties List", onClick: () => navigate("/property-search") },
    { title: "Auction Properties", onClick: () => navigate("/postbank-card") },
  ];

  return (
    <>
      {infoCards.map((card, index) => (
        <Box mb={2} key={index}>
          <Card onClick={card.onClick} sx={cardStyle}>
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "100%",
                px: 2,
                py: 0.5,
                backgroundColor: "#d8ccba",
                '&:last-child': {
                  pb: 0.5,
                }
              }}
            >
              <Typography
                variant="body1"
                fontWeight="600"
                color="#333"
                noWrap
                sx={{ flex: 1, pr: 1 }}
              >
                {card.title}
              </Typography>
              <IconButton sx={{ color: "#333" }}>
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            </CardContent>
          </Card>
        </Box>
      ))}
    </>
  );
};

export default InfoCards;